const middleware = {}

middleware['access'] = require('../middleware/access.ts')
middleware['access'] = middleware['access'].default || middleware['access']

export default middleware
